import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

import Back from '../common/Back';
import PrimaryButton from '../common/PrimaryButton';
import endReceivedIcon from '../../images/icons/icon-endorsement-status-received-18.svg';
import endDeclinedIcon from '../../images/icons/carrier-declinded-18.svg';
import endReviewingIcon from '../../images/icons/icon-endorsement-status-in-recieved-20.svg';
import endCompletedIcon from '../../images/icons/icon-endorsements-status-completed-20.svg';

import style from './EndorsementsPage.module.css';

const EndorsementsPage = React.memo(({ match, history }) => {
  const [endorsemets, setEndorsemets] = useState([]);
  const { clientId } = match.params;
  const onClick = event => {
    event.preventDefault();

    history.push(`/clients/${clientId}/requests/endorsement`);
  };

  const [clientInformation, setClientInformation] = useState({
    Name: '',
    ClientId: '',
  });

  const [sort, setSort] = useState({
    DateRequested: 'not',
    EndorsementType: 'not',
    LineOfBusiness: 'not',
    PolicyNumber: 'not',
    Status: 'not',
  });

  const handleSort = event => {
    const { attributes } = event.target;
    const sortDirection =
      attributes.direction.value === 'desc' ? 'asc' : 'desc';

    setSort(
      Object.assign(
        {},
        {
          DateRequested: 'not',
          EndorsementType: 'not',
          LineOfBusiness: 'not',
          PolicyNumber: 'not',
          Status: 'not',
        },
        { [attributes.sort.value]: sortDirection },
      ),
    );

    switch (sortDirection) {
      case 'desc':
        setEndorsemets(
          endorsemets.sort((a, b) => {
            if (a[attributes.sort.value] < b[attributes.sort.value]) {
              return -1;
            }
            if (a[attributes.sort.value] > b[attributes.sort.value]) {
              return 1;
            }
            return 0;
          }),
        );
        break;
      case 'asc':
        setEndorsemets(
          endorsemets.sort((a, b) => {
            if (b[attributes.sort.value] < a[attributes.sort.value]) {
              return -1;
            }
            if (b[attributes.sort.value] > a[attributes.sort.value]) {
              return 1;
            }
            return 0;
          }),
        );
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const handleSuccess = ({ data }) => {
      setEndorsemets(data);
    };

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}hub/clients/${clientId}/requests/endorsements`,
      )
      .then(handleSuccess);

    const handleClientInformationSuccess = ({ data }) => {
      setClientInformation(data);
    };

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}agency/clients/${clientId}/information`,
      )
      .then(handleClientInformationSuccess);
  }, [clientId]);

  const getIcon = status => {
    switch (status) {
      case 'Received':
        return <img src={endReceivedIcon} alt="" />;
      case 'Quote Not Accepted':
      case 'Carrier Declined':
        return <img src={endDeclinedIcon} alt="" />;
      case 'Carrier Reviewing':
      case 'Carrier Quoting':
        return <img src={endReviewingIcon} alt="" />;
      case 'Completed':
      case 'Quoted':
        return <img src={endCompletedIcon} alt="" />;
      default:
        return null;
    }
  };

  return (
    <div className={style.main}>
      <Back
        path={`/clients/${match.params.clientId}`}
        text={clientInformation.Name}
        clientId={clientInformation.ClientId}
      />
      <div className={style.header}>
        <h1>Endorsement Requests</h1>
        <PrimaryButton
          text="New Request"
          type="button"
          onClick={onClick}
          styles={{
            width: '200px',
            margin: 0,
            height: '43px',
            lineHheight: '40px',
            fontSize: '15px',
            letterSpacing: '-.2px',
            boxSizing: 'content-box',
          }}
        />
      </div>
      <table className={style.endorsements}>
        <thead>
          <tr>
            <th
              sort="DateRequested"
              direction={sort.DateRequested}
              onClick={handleSort}
              className={`${style.wHundredSixty} ${style[sort.DateRequested]}`}
            >
              Date Requested
            </th>
            <th
              sort="EndorsementType"
              direction={sort.EndorsementType}
              onClick={handleSort}
              className={`${style.wHundredFourty} ${
                style[sort.EndorsementType]
              }`}
            >
              Type of Change
            </th>
            <th
              sort="LineOfBusiness"
              direction={sort.LineOfBusiness}
              onClick={handleSort}
              className={`${style.wHundredFourty} ${
                style[sort.LineOfBusiness]
              }`}
            >
              Line of Business
            </th>
            <th
              sort="PolicyNumber"
              direction={sort.PolicyNumber}
              onClick={handleSort}
              className={`${style.wHundredFourty} ${style[sort.PolicyNumber]}`}
            >
              Policy Number
            </th>
            <th
              sort="Status"
              direction={sort.Status}
              onClick={handleSort}
              className={`${style.wHundredFourty} ${style[sort.Status]}`}
            >
              Status
            </th>
            <th className={style.wHundredFourty}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {endorsemets.map(item => {
            return (
              <tr key={item.RequestId}>
                <td>{item.DateRequested}</td>
                <td>{item.EndorsementType}</td>
                <td>{item.LineOfBusiness}</td>
                <td>{item.PolicyNumber}</td>
                <td>
                  {getIcon(item.Status)}
                  {item.Status}
                </td>
                <td className={style.last}>
                  <Link
                    className={style.viewDetails}
                    to={`/clients/${clientId}/endrosements/${item.RequestId}`}
                  >
                    View Request
                  </Link>
                </td>
              </tr>
            );
          })}
          {endorsemets.length === 0 && (
            <tr>
              <td colSpan="6">
                <div className={style.NotFound}>
                  <div>No endorsement requests found.</div>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
});

EndorsementsPage.propTypes = {};

export default EndorsementsPage;
